import { FC } from 'react';

import css from './FileSystemPage.module.css';

import { FileSystem } from 'v2/components/fileSystem/FileSystem';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const FileSystemPage: FC = () => (
  <PageLayout className={css.fileSystem}>
    <PageTitle>File System</PageTitle>

    <FileSystem />
  </PageLayout>
);
